export const calculateTextSize = (
  width: number,
  height: number,
  text: string,
) => {
  const minFontSize = 1.4;
  const maxFontSize = 12;

  // Calculate target size based on dimensions
  const aspectRatio = width / height;
  const isWide = aspectRatio > 2;
  const isNarrow = aspectRatio < 0.4;
  const isVeryNarrow = aspectRatio < 0.2;

  // Size thresholds
  const isSmallBox = width < 20 || height < 20;
  const isVerySmallBox = width < 15 || height < 15;

  // Standard padding ratio
  const standardPadding = 0.1;

  // Estimate text width based on character count
  const charCount = text.length;
  const avgCharWidthRatio = isSmallBox ? 0.6 : 0.5; // More conservative character width

  // Calculate base font size from width with size-based adjustments
  let fontSizeFromWidth;
  if (isVerySmallBox) {
    fontSizeFromWidth = (width * 0.8) / (charCount * avgCharWidthRatio);
  } else if (isSmallBox) {
    fontSizeFromWidth = (width * 0.6) / (charCount * avgCharWidthRatio);
  } else if (isVeryNarrow) {
    fontSizeFromWidth = (width * 0.5) / (charCount * avgCharWidthRatio);
  } else if (isNarrow) {
    fontSizeFromWidth = (width * 0.5) / (charCount * avgCharWidthRatio);
  } else if (isWide) {
    fontSizeFromWidth = (width * 0.2) / (charCount * avgCharWidthRatio);
  } else {
    fontSizeFromWidth = (width * 0.3) / (charCount * avgCharWidthRatio);
  }

  // Calculate font size from height with size-based adjustments
  let fontSizeFromHeight;
  if (isVerySmallBox) {
    fontSizeFromHeight = height * 0.5;
  } else if (isSmallBox) {
    fontSizeFromHeight = height * 0.3;
  } else if (isVeryNarrow) {
    fontSizeFromHeight = height * 0.12;
  } else if (isNarrow) {
    fontSizeFromHeight = height * 0.2;
  } else {
    fontSizeFromHeight = height * 0.2;
  }

  // Take the smaller of the two sizes to ensure text fits in both dimensions
  let calculatedSize = Math.min(fontSizeFromWidth, fontSizeFromHeight);

  // Account for padding
  calculatedSize *= 1 - standardPadding;

  // Apply minimum size based on box size and shape
  if (isVerySmallBox) {
    calculatedSize = Math.max(minFontSize, calculatedSize);
  } else if (isSmallBox) {
    calculatedSize = Math.max(1.2, calculatedSize);
  } else if (isVeryNarrow) {
    calculatedSize = Math.max(1.5, calculatedSize);
  } else if (isNarrow) {
    calculatedSize = Math.max(2, calculatedSize);
  } else {
    calculatedSize = Math.max(2.5, calculatedSize);
  }

  // Normalize sizes for better consistency
  if (calculatedSize > 8) {
    calculatedSize = 8 + (calculatedSize - 8) * 0.3;
  }

  // Additional scaling for small boxes
  if (isVerySmallBox) {
    calculatedSize *= 0.8;
  } else if (isSmallBox) {
    calculatedSize *= 0.9;
  }

  // Ensure we don't exceed max font size
  calculatedSize = Math.min(calculatedSize, maxFontSize);

  return Math.round(calculatedSize * 10) / 10; // Round to 1 decimal place
};
